import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Example data, replace with actual API calls
const classes = [
  { id: 1, name: 'Class 1' },
  { id: 2, name: 'Class 2' },
  { id: 3, name: 'Class 3' },
];

const sections = [
  { id: 1, classId: 1, name: 'Section A' },
  { id: 2, classId: 1, name: 'Section B' },
  { id: 3, classId: 2, name: 'Section A' },
  // Add more sections as needed
];

const students = [
  { id: 1, name: 'John Doe', sectionId: 1 },
  { id: 2, name: 'Jane Smith', sectionId: 1 },
  { id: 3, name: 'Emily Johnson', sectionId: 2 },
  // Add more students as needed
];

const feeHistory = [
  { studentId: 1, date: '2024-07-01', amount: 15000, receiptId: 'R001' },
  { studentId: 2, date: '2024-07-15', amount: 15000, receiptId: 'R002' },
  // Add more fee history as needed
];

function FeeReceipt() {
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [selectedStudent, setSelectedStudent] = useState('');
  const [studentFeeHistory, setStudentFeeHistory] = useState([]);

  useEffect(() => {
    // Filter fee history based on the selected student
    if (selectedStudent) {
      setStudentFeeHistory(feeHistory.filter(fee => fee.studentId === parseInt(selectedStudent)));
    } else {
      setStudentFeeHistory([]);
    }
  }, [selectedStudent]);

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
    setSelectedSection('');
    setSelectedStudent('');
  };

  const handleSectionChange = (e) => {
    setSelectedSection(e.target.value);
  };

  const handleStudentChange = (e) => {
    setSelectedStudent(e.target.value);
  };

  const handleSubmit = () => {
    // Implement logic to fetch fee history based on selected student
    console.log('Fetching fee history for student:', selectedStudent);
  };
  const Navigate = useNavigate();
  const viewReceipt = (receiptId) => {
    // Implement logic to view receipt details
      Navigate(`/fee-receipt-details/${receiptId}`)
  };

  return (
    <div className="w-full max-w-full p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-extrabold text-gray-800 mb-6">Fee Receipt</h1>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Select Class</label>
          <select
            value={selectedClass}
            onChange={handleClassChange}
            className="block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm py-2 px-3"
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.id} value={cls.id}>{cls.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Select Section</label>
          <select
            value={selectedSection}
            onChange={handleSectionChange}
            className="block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm py-2 px-3"
            disabled={!selectedClass}
          >
            <option value="">Select Section</option>
            {sections
              .filter((sec) => sec.classId === parseInt(selectedClass))
              .map((sec) => (
                <option key={sec.id} value={sec.id}>{sec.name}</option>
              ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Select Student</label>
          <select
            value={selectedStudent}
            onChange={handleStudentChange}
            className="block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm py-2 px-3"
            disabled={!selectedSection}
          >
            <option value="">Select Student</option>
            {students
              .filter((student) => student.sectionId === parseInt(selectedSection))
              .map((student) => (
                <option key={student.id} value={student.id}>{student.name}</option>
              ))}
          </select>
        </div>

        <button
          onClick={handleSubmit}
          className="mt-4 inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700"
        >
          Fetch Fee History
        </button>

        {studentFeeHistory.length > 0 && (
          <div className="mt-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Fee History</h2>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount (₹)</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Receipt</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {studentFeeHistory.map((fee) => (
                  <tr key={fee.receiptId}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{fee.date}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">₹{fee.amount}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{fee.receiptId}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600 hover:text-blue-800 cursor-pointer" onClick={() => viewReceipt(fee.receiptId)}>View Receipt</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default FeeReceipt;
